import type { Question, SolutionItem } from "./types"
import { SOLUTION_ITEMS } from "../constants"

const getDeepestRemainingQuestionDepth = (question: Question): number => {
  if (!question.options.length) {
    return 0
  }

  return Math.max(
    0,
    ...question.options.map((option) => {
      if (!option.nextQuestion) {
        return 0
      }

      return 1 + getDeepestRemainingQuestionDepth(option.nextQuestion)
    })
  )
}

// Ordered most specific first: the first rule whose items are all present wins.
const BUNDLE_SUBSTITUTIONS = [
  {
    replaces: [
      SOLUTION_ITEMS.counter.value,
      SOLUTION_ITEMS.printer.value,
      SOLUTION_ITEMS.barcode.value,
    ],
    bundle: SOLUTION_ITEMS.counterPrinterBarcode,
  },
  {
    replaces: [SOLUTION_ITEMS.counter.value, SOLUTION_ITEMS.printer.value],
    bundle: SOLUTION_ITEMS.counterPrinter,
  },
  {
    replaces: [SOLUTION_ITEMS.counter.value, SOLUTION_ITEMS.barcode.value],
    bundle: SOLUTION_ITEMS.counterBarcode,
  },
]

export const applyBundleSubstitutions = (
  solution: SolutionItem[]
): SolutionItem[] => {
  const substitution = BUNDLE_SUBSTITUTIONS.find((candidate) =>
    candidate.replaces.every((value) =>
      solution.some((item) => item.value === value)
    )
  )

  if (!substitution) {
    return solution
  }

  return [
    ...solution.filter((item) => !substitution.replaces.includes(item.value)),
    { ...substitution.bundle },
  ]
}

export const calculateTotalQuestions = (
  currentQuestion: Question,
  currentStep: number
): number => currentStep + getDeepestRemainingQuestionDepth(currentQuestion)

const ONLINE_PRODUCTS_SIGNUP_SERVICES = [
  { solutionValue: "invoices", signupService: "invoices" },
  { solutionValue: "payment_request", signupService: "payment_request" },
  { solutionValue: "gateway", signupService: "website" },
]

export const getOnlineProductsSignupUrl = (
  selectedServices: string[]
): string | undefined => {
  const signupUrl = process.env.GATSBY_SHOP_SIGNUP_URL

  if (!signupUrl) return undefined

  const services = ONLINE_PRODUCTS_SIGNUP_SERVICES.filter(({ solutionValue }) =>
    selectedServices.includes(solutionValue)
  ).map(({ signupService }) => signupService)

  if (!services.length) return undefined

  return `${signupUrl}?userJourney=online_products&services=${services.join(",")}`
}
